module.exports = __webpack_public_path__ + "img/PL08562.3c562525.png";